export class JSErrorTracking {

    static isEnabled() {
        return document.body.classList.contains("js-javascript-error-tracking-enabled");
    }

    static initializeWrapping() {
        if(this.isEnabled()){
            if (!window.trackJs) {
                return;
            }

            ["View", "Model", "Collection", "Router"].forEach(function (type) {
                var BackboneType = Backbone[type];
                Backbone[type] = BackboneType.extend({
                    constructor: function () {
                        // NOTE: This allows you to set _trackJs = false for any individual object
                        //       that you want excluded from tracking
                        if (typeof this._trackJs === "undefined") {
                            this._trackJs = true;
                        }

                        if (this._trackJs) {
                            // Additional parameters are excluded from watching. Constructors and Comparators
                            // have a lot of edge-cases that are difficult to wrap so we'll ignore them.
                            window.trackJs.watchAll(this, "model", "constructor", "comparator");
                        }

                        return BackboneType.prototype.constructor.apply(this, arguments);
                    }
                });
            });
        }
    }

    static setMetaData(error, value) {
        if(this.isEnabled()){
            if (!window.trackJs) return;
            window.trackJs.addMetadata(error, value);
        }
    }

    static sendCustomError(message) {
        if(this.isEnabled()) {
            if (!window.trackJs) {
                return;
            }
            window.trackJs.track(message);
        }
    }
}
